/** @deprecated */
export { MdProgressSpinner as MdProgressCircle } from './progress-spinner';
/** @deprecated */
export { MdProgressSpinnerModule as MdProgressCircleModule } from './progress-spinner';

//# sourceMappingURL=progress-circle.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@angular/material/progress-spinner/progress-circle.js
// module id = ./node_modules/@angular/material/progress-spinner/progress-circle.js
// module chunks = vendor